module.exports = __webpack_public_path__ + "img/66600.9e77781a.jpg";